<template>
  <v-container fluid class="mt-16">
    <div class="imprimir">
      <TicketDeCompra />
    </div>
    <div class="noimprimir">
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <v-col cols="12" lg="2">
                Cortes de caja
              </v-col>
              <v-spacer></v-spacer>
              <v-col lg="1" cols="6">
                <v-select
                  v-if="!switchAgruparPorSucursal"
                  style="margin-bottom:-26px;"
                  dense
                  clearable
                  v-model="usuarioBusquedaCorteCaja"
                  :items="usuariosNombresApellidos"
                  @input="consultaCortesDeCaja()"
                  label="Usuario"
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="2" cols="6">
                <v-select
                  style="margin-bottom:-26px;"
                  dense
                  item-text="NOMBRE"
                  item-value="NOMBRE"
                  clearable
                  v-model="sucursalBusquedaCorteCaja"
                  :items="sucursalesList"
                  @input="consultaCortesDeCaja()"
                  label="Sucursal"
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="2" cols="6">
                <v-menu
                  v-model="menuRangoFechas"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      style="height: 55px;margin-bottom:-15px;"
                      clearable
                      v-model="rangoDeFechas"
                      label="Elija un rango de fechas"
                      prepend-icon="mdi-calendar"
                      readonly
                      @input="consultaCortesDeCaja()"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    range
                    v-model="rangoDeFechas"
                    @input="
                      checarSiHayQueCerrarRango();
                      consultaCortesDeCaja();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col lg="2">
                <v-switch
                  @click="consultaCortesDeCaja()"
                  v-model="switchAgruparPorSucursal"
                  inset
                  label="Agrupar por sucursal"
                ></v-switch>
              </v-col>
              <v-col lg="1" cols="6">
                <v-select
                  style="margin-bottom:-26px !important;"
                  dense
                  :items="[5, 10, 15, 50]"
                  label="Elementos por página"
                  v-model="regPag"
                  outlined
                  @input="consultaCortesDeCaja()"
                ></v-select>
              </v-col>
              <v-col lg="2">
                <v-btn color="primary" @click="mostrarModalCorteCaja = true" block dark>
                  NUEVO CORTE DE CAJA
                </v-btn>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="cualHeader"
              :items="cortesDeCaja"
              :items-per-page="regPag"
              :page.sync="pag"
              @page-count="pageCount = $event"
              hide-default-footer
              :item-class="clasesRenglones"
            >
              <template #item.estadito="{ item }">
                <div>
                  <v-chip color="green" dark v-if="item.ESTADO == 1">Corte hecho</v-chip>
                  <v-chip color="red" dark v-else>Corte no hecho</v-chip>
                </div>
              </template>
              <template #item.entradaDeposito="{ item }">
                <div style="font-weight:bold;">{{ formateaMoneda(item.ENTRADA_DEPOSITO) }}</div>
              </template>
              <template #item.entradaEfectivo="{ item }">
                <div style="font-weight:bold;">{{ formateaMoneda(item.ENTRADA_EFECTIVO) }}</div>
              </template>
              <template #item.entradaTransferencia="{ item }">
                <div style="font-weight:bold;">
                  {{ formateaMoneda(item.ENTRADA_TRANSFERENCIA) }}
                </div>
              </template>
              <template #item.salidaEfectivo="{ item }">
                <div style="font-weight:bold;">{{ formateaMoneda(item.SALIDA_EFECTIVO) }}</div>
              </template>
              <template #item.imprimirTicketCorteDeCaja="{ item }">
                <v-btn @click="imprimirCorteDeCaja(item)" color="blue" dark text
                  >IMPRIMIR
                  <v-icon medium class="mr-2">
                    mdi-printer
                  </v-icon></v-btn
                >
              </template>
              <template #item.dineroActualCaja="{ item }">
                <div style="font-weight:bold;">
                  {{ formateaMoneda(item.ENTRADA_EFECTIVO - item.SALIDA_EFECTIVO) }}
                </div>
              </template>
              <template #item.botonHacerCorte="{ item }">
                <div>
                  <v-btn
                    @click="corteDeCajaPersonalizado(item)"
                    v-if="comparaFechas(item)"
                    color="blue"
                    dark
                    text
                    >HACER CORTE</v-btn
                  >
                </div>
              </template>
            </v-data-table>
          </v-card>
          <v-row>
            <v-col cols="0" lg="4"></v-col>
            <v-col cols="12" lg="4">
              <v-pagination
                @input="consultaCortesDeCaja(0)"
                v-model="pag"
                :length="paginacionCortesDeCaja"
              ></v-pagination>
            </v-col>
            <v-col cols="0" lg="4"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
    <ModalCorteDeCaja
      @muestra-dialog-exito="mostrarDialogExitoCorteDeCaja()"
      @cerrar-modal-corte-caja="
        mostrarModalCorteCaja = false;
        sucursalIDParaCorteDeCaja = 0;
      "
      :idParaCorteDeCaja="sucursalIDParaCorteDeCaja"
      v-if="mostrarModalCorteCaja"
      :show="mostrarModalCorteCaja"
    />
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import moment from "moment";
import ModalCorteDeCaja from "@/components/modales/ModalCorteDeCaja.vue";
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import { mapActions, mapState } from "vuex";

import _ from "lodash";
export default {
  data: () => ({
    switchAgruparPorSucursal: false,
    sucursalIDParaCorteDeCaja: 0,
    snackbarExito: false,
    usuarioBusquedaCorteCaja: "",
    sucursalBusquedaCorteCaja: "",
    mensajeSnackbarExito: "El corte de caja ha sido realizado con éxito.",
    menuRangoFechas: false,
    rangoDeFechas: [],
    pag: 1,
    regPag: 10,
    mostrarModalCorteCaja: false,
    busqueda: {
      usuario: ""
    },
    headers: [
      {
        text: "Fecha",
        align: "center",
        sortable: false,
        value: "FECHA"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      },
      {
        text: "Entrada depósito",
        align: "center",
        sortable: false,
        value: "entradaDeposito"
      },
      {
        text: "Entrada efectivo",
        align: "center",
        sortable: false,
        value: "entradaEfectivo"
      },
      {
        text: "Entrada transferencia",
        align: "center",
        sortable: false,
        value: "entradaTransferencia"
      },
      {
        text: "Salida efectivo",
        align: "center",
        sortable: false,
        value: "salidaEfectivo"
      },
      {
        text: "Estado",
        align: "center",
        sortable: false,
        value: "estadito"
      },
      {
        text: "Dinero actual caja",
        align: "center",
        sortable: false,
        value: "dineroActualCaja"
      },
      {
        text: "Usuario",
        align: "center",
        sortable: false,
        value: "USUARIO"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "imprimirTicketCorteDeCaja"
      }
      // {
      //   text: "",
      //   align: "center",
      //   sortable: false,
      //   value: "botonHacerCorte"
      // }
    ],
    headers2: [
      {
        text: "Fecha",
        align: "center",
        sortable: false,
        value: "FECHA"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      },
      {
        text: "Entrada depósito",
        align: "center",
        sortable: false,
        value: "entradaDeposito"
      },
      {
        text: "Entrada efectivo",
        align: "center",
        sortable: false,
        value: "entradaEfectivo"
      },
      {
        text: "Entrada transferencia",
        align: "center",
        sortable: false,
        value: "entradaTransferencia"
      },
      {
        text: "Salida efectivo",
        align: "center",
        sortable: false,
        value: "salidaEfectivo"
      },
      {
        text: "Dinero actual caja",
        align: "center",
        sortable: false,
        value: "dineroActualCaja"
      }
      // {
      //   text: "Estado",
      //   align: "center",
      //   sortable: false,
      //   value: "estadito"
      // }
      // {
      //   text: "",
      //   align: "center",
      //   sortable: false,
      //   value: "botonHacerCorte"
      // }
    ]
  }),
  components: {
    ModalCorteDeCaja,
    TicketDeCompra
  },
  methods: {
    ...mapActions("enviosInsercion", ["getEnviosParaExcel"]),
    ...mapActions("cortesDeCaja", ["getCortesDeCaja", "getCortesDeCajaAgrupado"]),
    ...mapActions("sucursales", ["getSucursales"]),
    ...mapActions("abonosEnvios", ["imprimirTicketCorteDeCaja"]),
    ...mapActions("usuarios", ["getUsuarios"]),
    async imprimirCorteDeCaja(item) {
      let dineroQueHayAhoraEnCaja = item.ENTRADA_EFECTIVO - item.SALIDA_EFECTIVO;
      await this.imprimirTicketCorteDeCaja({
        entradaDeDinero: item.ENTRADA_EFECTIVO,
        salidaDeDinero: item.SALIDA_EFECTIVO,
        usuarioCorte: item.USUARIO,
        fechaYHoraDelCorte: item.FECHA_HORA_CORTE,
        dineroActualEnCaja: dineroQueHayAhoraEnCaja
      });
      window.print();
    },
    clasesRenglones(item) {
      let Fecha = new Date();
      let DiaMes = Fecha.getDate() < 10 ? `0${Fecha.getDate()}` : Fecha.getDate();
      let Mes = Fecha.getMonth() + 1;
      let MesA = parseInt(Mes) < 10 ? `0${Mes}` : Mes;
      let Anio = Fecha.getFullYear();

      let FechaSistema = `${DiaMes}/${MesA}/${Anio}`;

      if (FechaSistema == item.FECHA) {
        return "indigo lighten-5 font-weight-black";
      }
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    comparaFechas(item) {
      return moment().format("L") == item.FECHA ? true : false;
    },
    consultaCortesDeCaja: _.debounce(async function(pagi = 1) {
      if (pagi == 1) {
        this.pag = 1;
      }
      if (this.rangoDeFechas == null) {
        this.rangoDeFechas = [];
      }
      if (!this.switchAgruparPorSucursal) {
        await this.getCortesDeCaja({
          pag: this.pag,
          regPag: this.regPag,
          usuario: this.usuarioEdit,
          sucursal: this.sucursalEdit,
          fechaInicio: this.rangoFechaInicial,
          fechaFin: this.rangoFechaFinal
        });
      } else {
        await this.getCortesDeCajaAgrupado({
          pag: this.pag,
          regPag: this.regPag,
          sucursal: this.sucursalEdit,
          fechaInicio: this.rangoFechaInicial,
          fechaFin: this.rangoFechaFinal
        });
      }
    }, 400),
    corteDeCajaPersonalizado(item) {
      this.sucursalIDParaCorteDeCaja = item.ID_SUCURSAL;
      this.mostrarModalCorteCaja = true;
    },
    checarSiHayQueCerrarRango() {
      if (this.rangoDeFechas[1]) {
        this.menuRangoFechas = false;
        this.consultaCortesDeCaja();
      }
    },
    async mostrarDialogExitoCorteDeCaja() {
      this.snackbarExito = true;
      this.consultaCortesDeCaja();
      this.mostrarModalCorteCaja = false;
    }
  },
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    ...mapState({
      cortesDeCaja: state => state.cortesDeCaja.cortesDeCaja,
      paginacionCortesDeCaja: state => state.cortesDeCaja.paginacionCortesDeCaja
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    ...mapState("usuarios", {
      usuariosL: state => state.listUsuarios
    }),
    ...mapState("enviosInsercion", {
      historialEnviosExcel: state => state.historialEnviosExcel
    }),
    cualHeader() {
      if (this.switchAgruparPorSucursal) {
        return this.headers2;
      } else {
        return this.headers;
      }
    },
    usuariosNombresApellidos() {
      let chale = [];
      for (var i = 0; i < this.usuariosL.length; i++) {
        chale.push(
          this.usuariosL[i].NOMBRE +
            " " +
            this.usuariosL[i].APELLIDO_P +
            " " +
            this.usuariosL[i].APELLIDO_M
        );
      }
      return chale;
    },
    usuarioEdit() {
      return this.usuarioBusquedaCorteCaja == "" || this.usuarioBusquedaCorteCaja == null
        ? ""
        : `&usuario=${this.usuarioBusquedaCorteCaja}`;
    },
    sucursalEdit() {
      return this.sucursalBusquedaCorteCaja == "" || this.sucursalBusquedaCorteCaja == null
        ? ""
        : `&sucursal=${this.sucursalBusquedaCorteCaja}`;
    },
    rangoFechaInicial() {
      return this.rangoDeFechas.length == 2
        ? `&fecha_inicio=${moment(this.rangoDeFechas[0]).format("L")}`
        : "";
    },
    rangoFechaFinal() {
      return this.rangoDeFechas.length == 2
        ? `&fecha_fin=${moment(this.rangoDeFechas[1]).format("L")}`
        : "";
    }
    //   numeroPaginas() {
    // if (this.historialEnvios.INFO) {
    //   return this.historialEnvios.INFO.paginacion.Paginas;
    // } else {
    //   return 0;
    // }
  },
  async mounted() {
    await this.consultaCortesDeCaja();
    await this.getSucursales();
    await this.getUsuarios();


  }
};
</script>
<style lang="css" scoped>
.imprimir {
  display: none;
}
@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
}
</style>
